var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: [_vm.$style.container, _vm.$style["container--size-".concat(_vm.size)]],
    on: {
      "click": function click($event) {
        return _vm.$emit('click');
      }
    }
  }, [_vm.getProjectImage ? _c('div', {
    class: _vm.$style.logo,
    style: _vm.getStyle
  }) : _c('div', {
    class: _vm.$style.empty
  }, [_vm._v(" " + _vm._s(_vm.getFirstChar) + " ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }